import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useMemo,
  type FC,
} from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { NumbersLayerStore } from 'pages/settings/pages/numbers/store/numbersLayerStore'
import { useSettingsContext } from 'pages/settings/context/settingsContext'

const NumbersLayerContext = createContext<NumbersLayerStore | null>(null)

export const useNumbersLayerContext = () => {
  const context = useContext(NumbersLayerContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with NumbersLayerProvider')

  return context
}

export const NumbersLayerProvider: FC<PropsWithChildren> = ({ children }) => {
  const settingsContext = useSettingsContext()
  const entities = useEntitiesContext()
  const store = useMemo(() => new NumbersLayerStore(settingsContext, entities), [settingsContext])

  useEffect(() => store.dispose, [])

  return <NumbersLayerContext.Provider value={store}>{children}</NumbersLayerContext.Provider>
}
